import { ChangeEventHandler } from 'react';
import styles from './Checkbox.module.css';
import { StyleProps } from './types';

type Props = StyleProps & {
	label?: string;
	checked?: boolean;
	onChange?: ChangeEventHandler<HTMLInputElement>;
};

const Checkbox = ({ label, onChange, checked, className, style }: Props) =>
{
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
	{
		onChange?.(event);
	};

	return (
		<div className={`${styles.container}${className ? ` ${className}` : ''}`} style={style} onClick={(e) => e.stopPropagation()}>
			{label && <label htmlFor='' className={styles.label}>{label}</label>}
			<div className={styles.box}>
				<input type="checkbox" onChange={handleChange} checked={checked} />
				<div></div>
			</div>
		</div>
	);
};

export default Checkbox;